import { z } from 'zod';
export const listResponse = (itemSchema) => z.object({
    items: z.array(itemSchema),
});
